// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

interface ComputeGetSelectorParams {
    catalogId: string;
}

export const computeGetSelector = ({ catalogId }: ComputeGetSelectorParams): QuerySelector => ({
    head: [{ name: 'getCatalog', idOrName: catalogId }],
    name: `get-pattern-${catalogId}`,
});
